var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormulateInput',_vm._b({attrs:{"type":"radio","label":_vm.label,"options":_vm.options,"validation":_vm.validation},on:{"blur-context":_vm.inputCallback,"validation":function($event){return _vm.$emit('validation', $event)}},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},'FormulateInput',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }